import type { FormOptionType } from "@/components/ui/form/_types/type";

import * as Model from "../../../../model";

export const SALES_MAST_TYPE_OPTIONS: Array<FormOptionType> = [
	{
		id: Model.Constants.SearchTypeForSearchSalesMastList.all,
		label: "全て",
		value: Model.Constants.SearchTypeForSearchSalesMastList.all,
	},
	{
		id: Model.Constants.SearchTypeForSearchSalesMastList.infoReservation,
		label: "宿泊料金",
		value: Model.Constants.SearchTypeForSearchSalesMastList.infoReservation,
	},
	{
		id: Model.Constants.SearchTypeForSearchSalesMastList.infoEC,
		label: "EC利用料金",
		value: Model.Constants.SearchTypeForSearchSalesMastList.infoEC,
	},
	{
		id: Model.Constants.SearchTypeForSearchSalesMastList.infoTicketBasic,
		label: "CHILLNN 基本プラン利用料金",
		value: Model.Constants.SearchTypeForSearchSalesMastList.infoTicketBasic,
	},
	{
		id: Model.Constants.SearchTypeForSearchSalesMastList.infoTicketPro,
		label: "CHILLNN 定額チケット利用料金",
		value: Model.Constants.SearchTypeForSearchSalesMastList.infoTicketPro,
	},
];
